<template>
  <div class="mt-auto mb-1 text-[10px] leading-none text-white/75">
    {{ displaySeconds }}
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  seconds: {
    type: Number,
    default: 0,
  },
});

const displaySeconds = computed(() => {
  const seconds = props.seconds;

  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
});
</script>
